import React from 'react';
import { Modal } from 'react-bootstrap';
import TelecmiRecordingAudio from './TelecmiRecordingAudio';

export default function TelecmiRecordingPlayerModal({
  show,
  onHide,
  filename,
}) {
  const name = filename == null ? '' : String(filename).trim();
  return (
    <Modal show={!!show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Recording</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {name ? (
          <TelecmiRecordingAudio
            filename={name}
            audioStyle={{ width: '100%' }}
            downloadVariant="icon"
          />
        ) : (
          <div style={{ fontSize: 12, color: '#666' }}>No recording filename</div>
        )}
      </Modal.Body>
    </Modal>
  );
}

